// extracted by mini-css-extract-plugin
export var banner = "_fb-0";
export var closeButton = "_fb-2";
export var greenCheckmark = "_fb-3";
export var hereLink = "_fb-4";
export var titleIcon = "_fb-1";